import { useTranslation } from 'react-i18next';
import { CircledIcon } from '../circled_icon';
import { PageContainer } from '../page_container';
import { PageHeader } from '../page_header';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { Button, Space, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import ReplayIcon from '@mui/icons-material/Replay';

export const ErrorPage = ({
  title,
  message,
  nextSteps,
  contactSupport,
  bottomSection,
}: {
  title?: string;
  message?: string;
  nextSteps?: string;
  contactSupport?: string;
  bottomSection?: 'none' | React.ReactNode;
}) => {
  const { t } = useTranslation(['errors', 'common']);

  return (
    <PageContainer>
      <PageHeader
        title={title ? title : t('default_error_title')}
        message={message ? message : t('default_error_message')}
      />
      <Space h={'var(--mantine-spacing-lg)'} />
      <CircledIcon icon={<ReportGmailerrorredIcon sx={{ fontSize: 48 }} />} />
      <Space h={'var(--mantine-spacing-lg)'} />
      <Text>{nextSteps ? nextSteps : t('default_error_next_steps')}</Text>
      <Space h={'var(--mantine-spacing-lg)'} />
      <Text>
        {contactSupport ? contactSupport : t('error_contact_support')}{' '}
        <Link
          to={'/'}
          style={{
            textDecoration: 'underline',
          }}
        >
          {t('support_team')}
        </Link>
        .
      </Text>
      {bottomSection !== 'none' &&
        (bottomSection ? (
          bottomSection
        ) : (
          <Button
            variant={'outline'}
            onClick={() => window.location.reload()}
            style={{
              position: 'absolute',
              bottom: 'var(--mantine-spacing-md)',
              right: 'var(--mantine-spacing-md)',
            }}
            rightSection={<ReplayIcon />}
          >
            {t('reload_page')}
          </Button>
        ))}
    </PageContainer>
  );
};
